const $body = 'body';
const $breadcrumb = '.rnk-componente-breadcrumb';
const $btnFake = '.btn-filtrar-fake';
const $appBar = 'download-app-show';
const $header = 'header';
let scroll: any;

$(window).scroll(function () {
  scroll = $(window).scrollTop();
  if ($($header).hasClass($appBar) == true) {
    $($breadcrumb).addClass('app-bar');
  } else {
    $($breadcrumb).removeClass('app-bar');
  }
  if ($($body).find($breadcrumb) && scroll > 50) {
    $($body).addClass('breadcrumb-fixed');
  } else {
    $($body).removeClass('breadcrumb-fixed');
  }
});

$($btnFake).click(function () {
  $('.btn-filtrar').click();
  return false;
});

export default {};
